import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { SHOP } from "../lib/shop";
import { Scissors, MapPin, Phone, Star, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  const { shop } = useAuth();
  const s = { ...SHOP, ...(shop || {}) };
  const wa = `https://wa.me/${s.whatsapp}?text=${encodeURIComponent("Hi Who's Next, I'd like to enquire about an appointment.")}`;
  const call = `tel:${(s.phone || "").replace(/\s/g, "")}`;

  return (
    <footer className="relative z-10 border-t border-white/10 bg-[#0A0A0A]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-10 h-10 rounded-full border border-[#D4AF37]/50 flex items-center justify-center">
              <Scissors className="w-5 h-5 text-[#D4AF37]" />
            </span>
            <span className="font-display text-2xl">{s.name}</span>
          </div>
          <p className="text-gray-400 max-w-sm leading-relaxed">
            {s.about || "Preston's premium grooming destination. Precision cuts, classic shaves and modern styling — crafted by master barbers."}
          </p>
          <div className="flex items-center gap-2 mt-6">
            <Star className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
            <span className="text-white font-medium">{s.rating}</span>
            <span className="text-gray-500 text-sm">Google Rating</span>
          </div>
          <div className="flex gap-3 mt-5">
            {s.instagram && <a href={s.instagram} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#D4AF37] transition-colors duration-200"><Instagram className="w-4 h-4 text-gray-300" /></a>}
            {s.facebook && <a href={s.facebook} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#D4AF37] transition-colors duration-200"><Facebook className="w-4 h-4 text-gray-300" /></a>}
          </div>
        </div>

        <div>
          <h4 className="label-caps mb-5">Explore</h4>
          <ul className="space-y-3 text-gray-400">
            {["Services", "Barbers", "Gallery", "Reviews", "Contact", "FAQ"].map((l) => (
              <li key={l}><Link to={`/${l.toLowerCase()}`} className="hover:text-[#D4AF37] transition-colors duration-200">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="label-caps mb-5">Visit Us</h4>
          <ul className="space-y-4 text-gray-400 text-sm">
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-[#D4AF37] shrink-0 mt-0.5" />{s.address}</li>
            <li className="flex gap-3"><Phone className="w-4 h-4 text-[#D4AF37] shrink-0 mt-0.5" /><a href={call} className="hover:text-[#D4AF37]">{s.phone}</a></li>
            <li><a href={wa} target="_blank" rel="noreferrer" className="text-[#D4AF37] hover:underline">WhatsApp us →</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-gray-500">
          <span>© {new Date().getFullYear()} {s.name}. All rights reserved.</span>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-gray-300">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-gray-300">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
